<template>
  <div class="balance-withdraw-modal">
    <div
      class="p-3 border rounded border-information-400 mb-5 bg-information-024"
    >
      <div class="d-flex gap-3">
        <bp-icon icon="fa fa-info-circle" class="text-information-500" />
        <span
          v-if="user.company.document"
          class="functional-1 text-information-800"
        >
          Certifique-se de que o documento da conta bancária seja o mesmo
          documento que está cadastrado em "Dados pessoais"
        </span>
        <span v-else class="functional-1 text-information-800">
          Configure seus dados pessoais antes de adicionar uma conta bancária
        </span>
      </div>
    </div>

    <div class="row align-items-end">
      <div class="col-lg-9 mb-5">
        <bp-select
          v-model="form.account"
          required
          size="xl"
          label="Selecionar conta bancária"
          :options="accountOptions"
          :description="
            `Seleciona em qual conta ${accountType} você deseja solicitar seu saque`
          "
        />
      </div>
      <div class="col-lg-3 mb-5">
        <bp-button
          block
          :disabled="!user.company.document"
          class="mb-0 mb-lg-6"
          size="xl"
          label="Nova conta"
          variant="filled-1"
          icon="fa-light fa-plus"
          @click="registerAccountModal = true"
        />
      </div>
      <div class="col-lg-6 mb-5">
        <bp-input
          v-model="amount"
          disabled
          size="xl"
          label="Saldo disponível"
          pre-icon="fa-regular fa-brazilian-real-sign"
        />
      </div>
      <div class="col-lg-6 mb-5">
        <bp-input
          v-model="form.withdrawValue"
          money
          required
          size="xl"
          label="Valor do saque"
          pre-icon="fa-regular fa-brazilian-real-sign"
          :money-config="{
            decimal: ',',
            thousands: '.',
            precision: 2,
            masked: false
          }"
        />
      </div>
    </div>

    <div class="amount-row">
      <span class="functional-1">
        Tarifa de saque
      </span>
      <span class="funcional-1 text-negative-600">
        R$ 1,99
      </span>
    </div>
    <div class="amount-row">
      <span class="functional-1">
        Total do débito
      </span>
      <span class="fw-6"> R$ {{ formatMoney(total) }} </span>
    </div>

    <div class="card py-5 px-3 mt-5 bg-transparent">
      <div class="row px-5">
        <div class="col-12 functional-1 mb-4">Detalhes :</div>
        <div class="col-lg-6 text-neutral-500">
          <div class="functional-1 mb-2">Pessoa Física</div>
          <ul class="functional-2">
            <li>Saque mínimo: R$ 20,00</li>
            <li>Saque máximo: R$ 20.000,00</li>
            <li>Tarifa de saque: R$ 1,99</li>
          </ul>
        </div>
        <div class="col-lg-6 text-neutral-500">
          <div class="functional-1 mb-2">Pessoa Jurídica</div>
          <ul class="functional-2">
            <li>Saque mínimo: R$ 20,00</li>
            <li>Saque máximo: Ilimitado</li>
            <li>Tarifa de saque: R$ 1,99</li>
          </ul>
        </div>
      </div>
      <hr class="my-4 mx-3" />
      <div class="px-5">
        <div class="functional-1 mb-4">Atenção :</div>
        <div class="functional-2 text-neutral-500">
          Prezamos pela segurança de todas as transações e seguimos rigorosos
          procedimentos de conformidade com as normas de Prevenção à Lavagem de
          Dinheiro (PLD) e Conheça Seu Cliente (KYC), garantindo assim que cada
          operação seja analisada com a devida cautela para a proteção de nossos
          clientes e da integridade financeira dos mesmos.
        </div>
      </div>
    </div>

    <footer-actions
      class="mt-7"
      label="Sacar"
      :loading="loading"
      :disabled="!isValid"
      @cancel="$emit('close')"
      @submit="confirmation = true"
    />

    <responsive-modal
      v-model="registerAccountModal"
      size="lg"
      title="Nova conta bancária"
    >
      <account-modal @close="registerAccountModal = false" />
    </responsive-modal>

    <confirmation
      v-model="confirmation"
      new-design
      @confirm="withdraw"
      confirm-button-class="btn-primary"
      :text="`Solicitar o saque de R$ ${formatMoney(form.withdrawValue)}`"
    />
    <confirmation
      v-model="successModal"
      new-design
      :show-cancel-button="false"
      confirm-button-text="Obrigado"
      confirm-button-class="btn-success"
      text="Saque solicitado com sucesso!!"
    />
  </div>
</template>
<script>
import AccountModal from "../user/FinancialData/AccountModal.vue";

import { formatMoney, formFields, isValidCNPJ } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  props: {
    balance: Object
  },
  components: { AccountModal },
  data() {
    return {
      ...formFields(["account", "withdrawValue"]),
      registerAccountModal: false,
      confirmation: false,
      successModal: false,
      loading: false
    };
  },
  computed: {
    ...mapState("financial", ["bankAccounts", "banksList"]),
    ...mapState("user", ["user"]),
    accountOptions() {
      return this.bankAccounts
        .filter(
          item =>
            item.type == this.accountType.toLowerCase() &&
            item.status == "approved"
        )
        .map(item => {
          let bank = this.banksList.find(b => b.id === item.bank);
          return {
            id: item.id,
            name: `${item.owner_account} - ${bank.compe} (Ag: ${item.agency}-${item.agency_vd} - Conta: ${item.number_account}-${item.number_account_vd})`
          };
        });
    },
    amount() {
      return formatMoney(this.balance.amount);
    },
    total() {
      return (this.form.withdrawValue || 0) - 1.99;
    },
    accountType() {
      return !this.user.company.document ||
        isValidCNPJ(this.user.company.document)
        ? "PJ"
        : "PF";
    },
    isValid() {
      return (
        this.form.account &&
        this.balance.amount &&
        this.form.withdrawValue &&
        this.form.withdrawValue >= 20 &&
        this.form.withdrawValue <= parseFloat(this.balance.amount) &&
        (this.form.withdrawValue <= 20000 || this.accountType === "PJ")
      );
    },
    valueError() {
      if (!this.form.withdrawValue) return [];

      if (this.form.withdrawValue < 20) {
        return [`O saque mínimo é de R$ ${formatMoney(20)}`];
      }

      if (this.form.withdrawValue > parseFloat(this.balance.amount)) {
        return [`Saldo insuficiente`];
      }

      if (this.form.withdrawValue > 20000 && this.accountType != "PJ") {
        return [
          `O saque máximo para pessoa física é de R$ ${formatMoney(20000)}`
        ];
      }
      return [];
    }
  },
  methods: {
    formatMoney,
    withdraw() {
      this.loading = true;
      this.$store
        .dispatch("financial/postWithdraw", {
          currency: "brl",
          amount: this.total.toFixed(2),
          account_bank_id: this.form.account
        })
        .then(() => {
          this.successModal = true;
        })
        .catch(error => {
          this.$message.error("Erro ao efetuar solicitação de saque");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    successModal(v) {
      if (!v) location.reload();
    }
  }
};
</script>
<style lang="scss" scoped>
.balance-withdraw-modal {
  .amount-row {
    display: flex;
    padding: 16px 8px;
    justify-content: space-between;
    border-bottom: 1px solid $neutral-048;
  }
  ul {
    margin: 0;
  }
}
</style>
